import { useEffect } from 'react';

const useFacebookSdk = () => {
// Load the SDK asynchronously
  // eslint-disable-next-line func-names
  const fbSdk = `! function (d, s, id) {
    let js; const
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    // eslint-disable-next-line prefer-const
    js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v3.2&appId=1983914755180097&autoLogAppEvents=1';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk')`;

  // Facebook Pixel Code
  const code = `! function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
          n.callMethod ?
              n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s)
  }(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '%REACT_APP_FB_PIXEL%');
  fbq('track', 'PageView');`;

  useEffect(() => {
    let load = true;
    // add script for facebook
    const scriptMainFb = document.createElement('script');
    scriptMainFb.text = code;
    scriptMainFb.async = true;
    document.body.appendChild(scriptMainFb);
    // add the sdk script
    const scriptSdk = document.createElement('script');
    scriptSdk.text = fbSdk;
    scriptSdk.async = true;
    document.body.appendChild(scriptSdk);
    return () => {
      if (load) {
        document.body.removeChild(scriptMainFb);
        document.body.removeChild(scriptSdk);
      }
      load = false;
    };
  }, []);
};
export default useFacebookSdk;
